export const content = {
  en: {
    nav: {
      hero: 'Home',
      position: 'Position',
      value: 'Value',
      commitment: 'Plan',
      challenges: 'Challenges',
      contact: 'Contact',
    },
    hero: {
      title: 'Building Intelligent Bridges to a Safer World',
      subtitle: 'Why I am the Ideal Candidate for Hikvision\'s Technical Support & Pre-Sales Engineer Role',
      name: 'Ivy (Yuwei) Xie',
    },
    position: {
      title: 'My Understanding: Beyond Troubleshooting, Creating Value',
      items: [
        {
          duty: 'Technical Support & Case Management',
          experience: 'At F&H Express, I served as the first point of contact, diagnosing technical issues and managing cases in Jira—directly aligning with troubleshooting and case recording requirements.',
        },
        {
          duty: 'Pre-Sales Support & Solution Design',
          experience: 'My experience translating business needs into technical specifications at F&H, combined with API integration at iHerb, equips me to design robust solutions and support PoCs.',
        },
        {
          duty: 'Project Delivery & Training',
          experience: 'I managed the end-to-end lifecycle of a Warehouse Management System, from deployment to user training, positioning me well for distributor technical support.',
        },
        {
          duty: 'Product Promotion & KPI Drive',
          experience: 'I am a proactive learner who improved operational efficiency by 35% through digital solutions, demonstrating my results-oriented approach.',
        },
      ],
    },
    value: {
      title: 'The Unique Value I Bring',
      cards: [
        {
          icon: 'Code',
          title: 'Full-Stack Problem Solving',
          description: 'With hands-on experience in .NET Core, React.js, and API integration, I understand system architecture, leading to faster diagnosis and better escalation to development teams.',
        },
        {
          icon: 'Languages',
          title: 'Seamless Cross-Cultural Communication',
          description: 'Native Mandarin and fluent English enable me to build trust with global distributors and ensure clear communication between headquarters and markets.',
        },
        {
          icon: 'Rocket',
          title: 'Product Mindset for Customer Success',
          description: 'I proactively analyze support patterns, contribute to knowledge bases, and focus on making products more successful for customers.',
        },
      ],
    },
    commitment: {
      title: 'My 6-Month Action Plan',
      phases: [
        {
          title: 'Month 1: Accelerated Learning',
          items: [
            'Immerse in Hikvision product documentation and technical manuals',
            'Complete internal training on core product lines',
            'Shadow senior support engineers on live cases',
          ],
        },
        {
          title: 'Months 2-3: Initial Contribution',
          items: [
            'Begin handling Tier-1 support cases independently',
            'Contribute to knowledge base with solution articles',
            'Assist in preparing product demonstrations and PoCs',
          ],
        },
        {
          title: 'Months 4-6: Value Ownership',
          items: [
            'Take ownership of technical support for key distributor accounts',
            'Co-deliver technical training sessions to distributors',
            'Become a go-to expert for specific Hikvision product lines',
          ],
        },
      ],
    },
    challenges: {
      title: 'Challenges I Anticipate & Am Prepared For',
      intro: 'I have researched this role thoroughly and understand that excellence requires navigating challenges in these key areas:',
      categories: [
        {
          name: 'Complex Technical Troubleshooting',
          points: [
            'Product Integration & Compatibility: Diagnosing protocol issues (e.g., ONVIF) when our cameras and NVRs fail to work seamlessly with third-party access control or alarm systems.',
            'Network Issues: Solving IP conflicts, insufficient switch bandwidth, firewall port blockages, or VLAN misconfigurations that cause device drop-offs or video lag.',
            'Software Configuration: Pinpointing incorrect settings among countless options in iVMS-4200 or device menus that lead to feature malfunctions.',
            'Hardware Failure Diagnosis: Determining the root cause of image problems—whether it\'s a damaged lens, sensor issue, power supply problem, or simply a dirty lens.',
          ],
        },
        {
          name: 'Communication with Clients & Distributors',
          points: [
            'Varying Technical Expertise: Adapting my explanations from deep technical details for expert engineers to simple, step-by-step guidance for beginners.',
            'Managing Emotions & Expectations: Calming frustrated clients during critical project phases and providing clear solution paths without promising immediate fixes.',
            'Language & Cultural Nuances: Ensuring technical guidance is understood accurately across different regions, avoiding miscommunication.',
          ],
        },
        {
          name: 'Pre-Sales & Solution Design',
          points: [
            'Translating Vague Requirements: Turning a client\'s need (e.g., "a system to prevent intrusion") into a detailed solution by asking the right questions about scope, lighting, and alerts.',
            'Pressure of Proof-of-Concept (PoC): Setting up flawless demos on-site where any minor failure could risk losing a major deal.',
            'Understanding Competitors: Knowledgeably comparing Hikvision products against competitors (like Axis or Bosch) to highlight our advantages.',
          ],
        },
        {
          name: 'Internal Process & Self-Management',
          points: [
            'Balancing Case Priority: Quickly judging which issue demands immediate attention—a minor bug versus a system-wide failure—and managing client expectations accordingly.',
            'Constant Learning: Keeping pace with Hikvision\'s rapidly updating product lines and firmware to stay effective.',
          ],
        },
      ],
    },
    contact: {
      title: 'Thank You',
      subtitle: 'I look forward to discussing how I can contribute to Hikvision\'s global success',
      name: 'Ivy Xie',
      phone: '+61 413025124',
      email: 'ivyxie.work@gmail.com',
    },
  },
  zh: {
    nav: {
      hero: '首页',
      position: '职位理解',
      value: '核心价值',
      commitment: '行动计划',
      challenges: '挑战',
      contact: '联系方式',
    },
    hero: {
      title: '构建更安全世界的智能桥梁',
      subtitle: '我为何是海康威视技术支援与售前工程师的理想人选',
      name: '解雨微 (Ivy)',
    },
    position: {
      title: '我的理解：不只是解决故障，更是创造价值',
      items: [
        {
          duty: '技术支援与案例管理',
          experience: '在F&H Express，我作为一线技术支持，使用Jira诊断问题和管理案例——这与岗位的故障排查和案例记录要求完全吻合。',
        },
        {
          duty: '售前支持与方案设计',
          experience: '我在F&H将业务需求转化为技术方案的经验，加上在iHerb的API集成经验，使我能够设计稳健的解决方案并支持概念验证。',
        },
        {
          duty: '项目交付与培训',
          experience: '我全面管理过仓库管理系统的生命周期，从部署到用户培训，这为支持分销商技术培训做好了准备。',
        },
        {
          duty: '产品推广与KPI驱动',
          experience: '我通过数字化解决方案将运营效率提升35%，证明了我对成果的追求和主动学习能力。',
        },
      ],
    },
    value: {
      title: '我能带来的独特价值',
      cards: [
        {
          icon: 'Code',
          title: '全栈式问题解决能力',
          description: '拥有.NET Core、React.js和API集成的实战经验，能从系统架构层面理解问题，实现更快速的诊断和更精准的升级处理。',
        },
        {
          icon: 'Languages',
          title: '无缝的跨文化沟通',
          description: '母语级中文和流利英文，能够与全球分销商建立信任，确保总部与市场间信息的准确传递。',
        },
        {
          icon: 'Rocket',
          title: '以产品思维驱动客户成功',
          description: '我主动分析支持案例模式，完善知识库，专注于如何让产品更好地帮助客户成功。',
        },
      ],
    },
    commitment: {
      title: '我的6个月行动计划',
      phases: [
        {
          title: '第1个月：加速学习',
          items: [
            '深入学习海康威视产品文档和技术手册',
            '完成核心产品线的内部培训',
            '跟随资深工程师处理实际案例',
          ],
        },
        {
          title: '第2-3个月：初步贡献',
          items: [
            '开始独立处理一线支持案例',
            '撰写解决方案文章，完善知识库',
            '协助准备产品演示和概念验证',
          ],
        },
        {
          title: '第4-6个月：价值主导',
          items: [
            '负责关键分销商账户的技术支持',
            '共同为分销商提供技术培训',
            '成为特定产品线的技术专家',
          ],
        },
      ],
    },
    challenges: {
      title: '我预见并已做好准备的挑战',
      intro: '我深入研究了这一职位，并理解要胜任它，需要应对以下几个关键领域的挑战：',
      categories: [
        {
          name: '复杂的技术排查问题',
          points: [
            '产品集成与兼容性：当我们的摄像头、NVR与第三方门禁或报警系统无法协同工作时，诊断协议问题。',
            '网络问题：解决IP地址冲突、交换机带宽不足、防火墙端口未开放或VLAN划分错误等导致设备掉线或视频卡顿的问题。',
            '软件配置错误：在海量的iVMS-4200客户端或设备菜单设置中，精准找出导致功能异常的错误配置。',
            '硬件故障判断：判断图像问题的根本原因——是镜头物理损坏、传感器问题、电源问题，还是单纯的镜头脏了。',
          ],
        },
        {
          name: '与客户及分销商的沟通',
          points: [
            '技术能力不均：根据沟通对象调整解释方式，从与专家工程师探讨技术细节，到为初学者提供一步步的简单指导。',
            '情绪与期望值管理：在项目关键阶段安抚沮丧的客户，在不承诺立即解决所有问题的前提下，提供清晰的解决路径。',
            '语言与文化差异：确保技术指导在不同地区能被准确理解，避免因沟通偏差导致错误操作。',
          ],
        },
        {
          name: '售前支持与方案设计',
          points: [
            '将模糊需求转化为方案：通过询问范围、光线条件、报警方式等关键细节，将客户的模糊需求转化为包含具体产品型号和配置的完整解决方案。',
            '概念验证的压力：在现场搭建并完美演示临时系统，任何小故障都可能导致丢单，压力巨大。',
            '理解竞争对手：深入了解竞争对手的产品，以便在比较中清晰地阐述海康威视产品的优势和差异化价值。',
          ],
        },
        {
          name: '内部流程与自我管理',
          points: [
            '案例优先级平衡：快速判断问题优先级——是小故障还是导致系统瘫痪的紧急事件——并据此合理分配精力，管理客户预期。',
            '持续学习压力：跟上海康威视快速更新的产品线和固件版本，以保持高效解决问题的能力。',
          ],
        },
      ],
    },
    contact: {
      title: '感谢观看',
      subtitle: '期待与您进一步探讨如何为海康威视的全球团队贡献力量',
      name: '解雨微',
      phone: '+61 413025124',
      email: 'ivyxie.work@gmail.com',
    },
  },
};